import { SelectOptionsHook, SingleSelect } from "@coherehealth/common";
import { useSearchAuditTags } from "@coherehealth/qm-api";
import { useEffect, useMemo } from "react";
import debounce from "lodash/debounce";

interface AuditTagSelectProps {
  value: string;
  onChange: (value: string) => void;
}

export const AuditTagSelect = ({ value, onChange }: AuditTagSelectProps) => {
  return (
    <div style={{ marginTop: 24 }}>
      <SingleSelect
        autoHighlight
        useOptions={useAuditTagOptions}
        label="Audit tag"
        setSelectedValue={(option: string | null) => onChange?.(option || "")}
        getOptionLabel={(option: string) => option}
        selectedValue={value}
        fullWidth
        markSelectedOptions={false}
        inputValue={value}
        onInputChange={(_, value) => onChange?.(value)}
        freeSolo
        helperText="Type to search for existing tags or create a new one"
      />
    </div>
  );
};

const useAuditTagOptions: SelectOptionsHook<string> = ({ query }) => {
  const {
    data: options,
    loading,
    refetch: search,
  } = useSearchAuditTags({
    queryParams: {
      query: query || "",
      limit: 5,
    },
    lazy: true,
  });

  const debouncedSearch = useMemo(() => debounce(search, 300), [search]);

  useEffect(() => {
    let ignore = false;
    if (query && !ignore) {
      debouncedSearch();
    }
    return () => {
      debouncedSearch.cancel();
      ignore = true;
    };
  }, [debouncedSearch, query]);

  return {
    optionsLoading: loading,
    options: options || [],
  };
};
